<template>
  <header class="site-header">
    <div class="container">
      <router-link to="/" class="logo">MindYourBite</router-link>
      <nav>
        <!-- Add navigation links here if needed in the future -->
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader'
}
</script>

<style scoped>
.site-header {
  padding: 20px 0;
  background-color: #fff;
  border-bottom: 1px solid #eaeaea;
}
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.logo {
  font-size: 24px;
  font-weight: bold;
  text-decoration: none;
  color: #2c3e50;
}
</style>
